"use client";

import { useLang } from "@/contexts/language-context";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Link from "next/link";

export default function FoodTruckQsrCta() {
  const { t } = useLang();

  return (
    <section className="py-28 px-6 bg-redy-charcoal text-white relative overflow-hidden">
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-redy-orange/20 rounded-full blur-[160px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-redy-red/15 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative max-w-[820px] mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-[44px] md:text-[68px] font-black leading-[1.02] tracking-tight mb-6"
        >
          {t("Start your food truck POS.", "Empieza tu POS de food truck.")}
          <br />
          <span className="redy-text-gradient">{t("Free software plan.", "Plan de software gratis.")}</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg text-white/70 max-w-[520px] mx-auto mb-10 font-medium"
        >
          {t(
            "$0/month software plan when you process with Redy. Card payers cover the processing cost. Cash keeps ringing when the signal drops.",
            "Plan de software de $0/mes procesando con Redy. Quien paga con tarjeta cubre el procesamiento. El efectivo sigue aunque caiga la señal."
          )}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-3 justify-center"
        >
          <Link
            href="/auth/sign-up"
            className="inline-flex items-center justify-center gap-2 bg-white text-redy-charcoal hover:bg-redy-orange hover:text-white px-8 py-4 rounded-full font-bold text-sm transition-all hover:scale-[1.02]"
          >
            {t("Get started free", "Empieza gratis")}
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            href="/pricing"
            className="inline-flex items-center justify-center gap-2 bg-white/[0.08] border border-white/15 hover:bg-white/[0.15] text-white px-8 py-4 rounded-full font-bold text-sm transition-all"
          >
            {t("See pricing", "Ver precios")}
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
